import { createFileRoute } from "@tanstack/react-router";
import { HelpHub } from "../admin/help";

export const Route = createFileRoute("/teacher/help")({ component: () => <HelpHub portal="teacher" /> });
